import { ButtonTransparent } from "@/stories/Button.stories";
import { CardSm } from "@/stories/Card.stories";
import { EffectCards } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import type { CardSliderType } from "../../../BlogTypes";
import Button from "../Cards/Button";
import Card from "../Cards/Card";
import "swiper/css";
import "swiper/css/effect-cards";
import Link from "next/link";
interface CardSliderProps {
    slideContent: CardSliderType[];
}

export default function CardSlider({ slideContent }: CardSliderProps) {
    return (
        <div>
            <Swiper
                effect={"cards"}
                grabCursor={true}
                modules={[EffectCards]}
                className="mySwiper"
            >
                {slideContent.map((card) => {
                    return (
                        <SwiperSlide key={card.url}>
                            <>
                                <Link href={card.url}>
                                    <Card
                                        button={
                                            <div className="pb-10">
                                                <Button
                                                    backgroundColor={card.color}
                                                    textColor={
                                                        ButtonTransparent.args?.textColor
                                                    }
                                                    border={
                                                        ButtonTransparent.args?.border
                                                    }
                                                    as="a"
                                                    href={card.url}
                                                />
                                            </div>
                                        }
                                        buttonPlacement={CardSm.args?.buttonPlacement}
                                        width={"w-55 justify-center items-center"}
                                        height={"h-56 p-7"}
                                        imageSize={CardSm.args?.imageSize}
                                        imgSrc={card.img}
                                        title={card.title}
                                        backgroundColor={card.color}
                                        titleSize={CardSm.args?.titleSize}
                                        hasButton={false}
                                        titlePlacement="text-center"
                                        spacing={CardSm.args?.spacing}
                                    />
                                </Link>
                            </>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
}
